import { rgba } from 'polished';
import styled from 'styled-components';

import { TableView } from '#/features/options/option-tables-context';
import * as OptionFn from '#/features/options/functions';
import { mainGridGapColor, cFFFFFF } from '#/colors';

export default function TableTitle(props: { optionTableView: TableView }) {
  const { optionTableView } = props;

  return (
    <Container>
      <Type css="justify-self: start;">Calls</Type>
      <Secondary css="justify-self: end;">
        {/* WIP */}
        {/* Underlying Price: $19,519.26 */}
      </Secondary>
      <ExpiryDate css="justify-self: center;">
        {OptionFn.formatExpiryDate(optionTableView.expiryDate)}
      </ExpiryDate>
      <Secondary css="justify-self: start;">
        {/* WIP */}
        {/* Expires in: 0 days, 23 hours, 14 minutes */}
      </Secondary>
      <Type css="justify-self: end;">Puts</Type>
    </Container>
  );
}

const Container = styled.div`
  height: 38px;
  display: grid;
  align-items: center;
  grid-template-columns: 40px 1fr 240px 1fr 40px;

  padding: 0 16px;
  border-bottom: 1px solid ${mainGridGapColor};
`;

const ExpiryDate = styled.span`
  font-size: 14px;
  font-weight: 500;
  text-transform: uppercase;
`;

const Type = styled.span`
  font-size: 14px;
  font-weight: 500;
`;

const Secondary = styled.span`
  color: ${rgba(cFFFFFF, 0.5)};
  font-size: 12px;
  font-weight: 500;
`;
